module.exports = __webpack_public_path__ + "static/media/img124_R.a94b84ae.jpg";